import { render, staticRenderFns } from "./InternalDepartment.vue?vue&type=template&id=53ae45e9&"
import script from "./InternalDepartment.vue?vue&type=script&lang=js&"
export * from "./InternalDepartment.vue?vue&type=script&lang=js&"
import style0 from "./InternalDepartment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports